import { useMemo } from 'react';
import { useTheme } from '../../theme';

export interface UseContainerLayoutResponse {
  body: {
    paddingX: number;
    paddingY: number;
  };
  container: {
    /**
     * Border width to use on the `Container` when it is nested.
     */
    nestedBorderWidth: number;
    paddingX: number;
    paddingY: number;
  };
  header: {
    height: number;
  };
}

/**
 * Hook that provides some constants related to the layout of the `Container`.
 * Primarily used by `VizPanel` to programmatically handle panel layouts and ensure they stay in
 * sync with the `Container`.
 */
export const useContainerLayout = (): UseContainerLayoutResponse => {
  const { theme } = useTheme();

  return useMemo(() => {
    // Note: we parse the numbers from the pixel values we get back from `theme.spacing` because we
    // need these numbers for doing math.
    return {
      container: {
        nestedBorderWidth: 1,
        paddingY: parseFloat(theme.spacing(1)),
        paddingX: parseFloat(theme.spacing(2)),
      },
      header: {
        height: 32,
      },
      body: {
        paddingY: parseFloat(theme.spacing(1)),
        paddingX: 0,
      },
    };
  }, [theme]);
};
